<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="purchasePlanDetails"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-upload
            action=""
            :http-request="importFile"
            :show-file-list="false"
            accept=".xlsx,.xls"
            style="float: left; margin-right: 4px;">
          <el-button type="primary" :loading="importLoading">导入</el-button>
        </el-upload>
        <el-button
            type="primary"
            plain
            icon="el-icon-download"
            style="margin-left: 6px;"
            @click="downloadTemplate">
          模板下载
        </el-button>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.rejectAuth && scope.row.status === 30"
            type="warning"
            size="mini"
            :disabled="!scope.row.pkid"
            @click="rejectHandle(scope.row)"
        >
          驳回
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入编号" clearable/>
          </el-form-item>
          <el-form-item label="采购订单号">
            <el-input v-model.trim="filter.purchaseOrderNo" placeholder="请输入采购订单号" clearable/>
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料号" clearable/>
          </el-form-item>
          <el-form-item label="物料描述">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料描述" clearable/>
          </el-form-item>
          <el-form-item label="供应商编码">
            <el-input v-model.trim="filter.supplierNo" placeholder="请输入供应商编码" clearable/>
          </el-form-item>
          <el-form-item label="供应商">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入供应商" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status" clearable placeholder="请选择状态">
              <el-option label="全部" value="-1"/>
              <el-option label="供应商未确认" value="0"/>
              <el-option label="采购驳回" value="10"/>
              <el-option label="采购未确认" value="20"/>
              <el-option label="供应商已确认" value="30"/>
              <el-option label="作废" value="99"/>
            </el-select>
          </el-form-item>
          <el-form-item label="要货类型">
            <el-select v-model="filter.type" clearable placeholder="请选择要货类型">
              <el-option label="全部" value="0"/>
              <el-option label="生产要货" value="1"/>
              <el-option label="发货要货" value="2"/>
            </el-select>
          </el-form-item>
          <el-form-item label="是否加急">
            <el-select v-model="filter.urgent" clearable placeholder="请选择是否加急">
              <el-option label="全部" value="-1"/>
              <el-option label="否" value="0"/>
              <el-option label="是" value="1"/>
            </el-select>
          </el-form-item>
          <el-form-item label="需求日期">
            <el-date-picker
                v-model="requireDeliveryDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('requireDeliveryDateRange', 'requireDeliveryDateBegin', 'requireDeliveryDateEnd')"/>
          </el-form-item>
          <el-form-item label="送货日期">
            <el-date-picker
                v-model="deliveryDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('deliveryDateRange', 'deliveryDateBegin', 'deliveryDateEnd')"/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <purchase-plan-detail ref="detail" @save-success="loadData"/>
    <purchase-plan-manual-add ref="manualAdd" @save-success="loadData"/>
  </div>
</template>
<script>
  import PurchasePlanDetail from "@/views/PurchaseOrderManager/PurchasePlan/PurchasePlanDetail";
  import PurchasePlanManualAdd from "@/views/PurchaseOrderManager/PurchasePlan/PurchasePlanManualAdd";
  import ViewTable from "@/components/ViewTable";

  export default {
    name: "PurchasePlanList",
    components: {ViewTable, PurchasePlanDetail, PurchasePlanManualAdd},
    data() {
      return {
        limits: {
          addAuth: this.$auth(458),
          delAuth: this.$auth(458),
          rejectAuth: this.$auth(142),
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "billNo",
            align: "center",
            width: 150,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.detail.open(params.row);
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            key: "billTitle",
            align: "center",
            width: 300,
            tooltip: true,
          },
          {
            key: "purchaseOrderNo",
            align: "center",
            width: 150,
            tooltip: true,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.detail.open(params.row);
                    },
                  },
                },
                params.row.purchaseOrderNo,
              );
            },

          },
          {
            key: "poDetailRowNo",
            align: "center",
            width: 150,
            tooltip: true,
          },
          {
            key: "materialNo",
            align: "center",
            width: 130,
            tooltip: true,
          },
          {
            key: "materialDesc",
            align: "center",
            width: 220,
            tooltip: true,
          },
          {
            tooltip: true,
            key: "urgent",
            align: "center",
            width: 100,
            render: (h, params) => {
              return params.row.urgent ? h(
                "span",
                {
                  style: {
                    color: "#F02D3D",
                    cursor: "pointer",
                  },
                },
                "是",
              ) : h(
                "span",
                {
                  style: {
                    cursor: "pointer",
                  },
                },
                "否",
              );
            },
          },
          {
            key: "supplierCode",
            width: 120,
            align: "center",
            tooltip: true,
          },
          {
            key: "supplierName",
            width: 120,
            align: "center",
            tooltip: true,
          },
          {
            key: "requireDeliveryDate",
            width: 100,
            align: "center",
            tooltip: true,
          },
          {
            key: "deliveryDate",
            width: 100,
            align: "center",
            tooltip: true,
          },
          {
            key: "actualQuantity",
            width: 100,
            align: "center",
            tooltip: true,
          },
          {
            key: "quantity",
            width: 100,
            align: "center",
            tooltip: true,
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
            tooltip: true,
          },
          {
            key: "roundedValue",
            width: 100,
            align: "center",
            tooltip: true,
          },
          {
            key: "action",
            align: "center",
            width: 210,
            slot: "action",
            fixed: "right",
          },
        ],
        submitLoading: false,
        importLoading: false,
        requireDeliveryDateRange:[],
        deliveryDateRange:[],
        filter: {
          materialNo:"",
          materialName:"",
          supplierNo:"",
          supplierName:"",
          billNo:"",
          purchaseOrderNo:"",
          status:"",
          type:"",
          urgent:"",
          requireDeliveryDateBegin:"",
          deliveryDateBegin:"",
          requireDeliveryDateEnd:"",
          deliveryDateEnd:"",
        },
      };
    },
    mounted() {
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      addEditHandle() {
        this.$refs.manualAdd.open();
      },
      // 导入要货计划
      importFile(params) {
        this.importLoading = true;
        const formData = new FormData();
        formData.append("file", params.file);
        this.$http.post("basic", "purchasePlans/importFile", formData).then((res) => {
          this.importLoading = false;
          if (res.success) {
            this.$message.success("导入成功");
            this.loadData(1);
          } else {
            this.$message.error(res.msg || "导入失败");
          }
        }).catch(() => {
          this.importLoading = false;
        });
      },
      // 下载导入模板
      downloadTemplate() {
        window.open("/file/要货计划导入模板.xlsx");
      },

      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `purchasePlans/submit/${row.pkid}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.submitLoading = false;
              this.loadData();
            }
          });
        });
      },
      // 驳回：将主单与明细状态重置为"供应商未确认"，让供应商重新回复交期
      rejectHandle(row) {
        this.$confirm("确定驳回该要货计划吗？驳回后状态将初始化为【供应商未确认】。", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", `purchasePlans/reject/${row.masterId}`).then((resp) => {
            if (resp.success) {
              this.$message.success("驳回成功");
              this.loadData();
            } else {
              this.$message.error(resp.msg || "驳回失败");
            }
          });
        }).catch(() => {});
      },
      selectHandle(selection) {
        this.selection = selection;
      },
      resetHandle(filter) {
        this.filter = filter;
      },
      deleteHandle(row) {
        this.$http.delete("basic", "purchasePlans", row.masterId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "purchasePlans", row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },

      //未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.status === 0) {
          return  false;
        } else {
          return  true;
        }
      },
    },
  };
</script>
<style lang="scss" scoped></style>
